import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { store } from 'redux-rest-reducer';

import FilterDropdown from 'comps/filter/filter-dropdown';
import { BATCHES_CONFIG, USER_CONFIG } from 'constants/api';
import { FORM_ACTIONS } from 'constants/form';
import { getOptions } from 'modules/form';
import { LinkNav, TableWrapper } from '../utils/styled-components';

export const demoOptions = [
  {
    label: 'True',
    value: true,
  },
  {
    label: 'False',
    value: false,
  },
];

class StudentList extends PureComponent {
  onFilteredChange = filters => {
    this.props.onFilter(filters);
  };

  render() {
    const { students, userConfig, programs } = this.props;

    let gradeOptions = [];
    let stateOptions = [];

    if (userConfig && programs) {
      gradeOptions = getOptions({ field: 'grade', userConfig, programs });
      stateOptions = getOptions({ field: 'studentState', userConfig, programs });
    }

    const tableColumns = [
      {
        Header: `Students`,
        columns: [
          {
            Header: 'Name',
            accessor: 'name',
            width: 200,
            Cell: row => {
              return (
                <LinkNav
                  target="_blank"
                  to={{
                    pathname: `/student-pii/${row.original.id}`,
                    state: {
                      formType: FORM_ACTIONS.CREATE,
                      student: row.original,
                    },
                  }}
                >
                  {row.original.name}
                </LinkNav>
              );
            },
          },
          {
            Header: 'Parent Service Id',
            accessor: 'parent_service_id',
            width: 200,
          },
          {
            Header: 'Grade',
            accessor: 'grade',
            width: 100,
            fixed: 'top',
            filterable: true,
            Filter: ({ filter, onChange }) => {
              return (
                <FilterDropdown
                  options_list={gradeOptions}
                  filter={filter}
                  onChange={onChange}
                  multiple={true}
                />
              );
            },
          },
          {
            Header: 'State',
            accessor: 'state',
            width: 100,
            filterable: true,
            Filter: ({ filter, onChange }) => {
              return (
                <FilterDropdown
                  options_list={stateOptions}
                  filter={filter}
                  onChange={onChange}
                  multiple={true}
                />
              );
            },
          },
          {
            Header: 'Demo State',
            accessor: 'demo_state',
            width: 150,
          },
          {
            Header: 'Country',
            accessor: 'country',
            width: 150,
          },
          {
            Header: 'Test Account',
            accessor: 'is_demo',
            width: 120,
            Cell: ({ value }) => (value ? 'True' : 'False'),
            filterable: true,
            Filter: ({ filter, onChange }) => {
              return (
                <FilterDropdown
                  options_list={demoOptions}
                  filter={filter}
                  onChange={onChange}
                  multiple={false}
                />
              );
            },
          },
          {
            Header: 'Leap Student',
            accessor: 'is_hybrid',
            width: 120,
            Cell: ({ value }) => (value ? 'False' : 'True'),
          },
        ],
      },
    ];
    return (
      <React.Fragment>
        <TableWrapper>
          <ReactTable
            data={students}
            className="-striped -highlight"
            manual
            showPageSizeOptions={false}
            filterable={false}
            sortable={false}
            resizable={false}
            defaultPageSize={20}
            onFilteredChange={this.onFilteredChange}
            defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
            columns={tableColumns}
            style={{ textAlign: 'center' }}
          />
        </TableWrapper>
      </React.Fragment>
    );
  }
}

export default connect(
  ({ configs, programs }) => ({
    userConfig: store.get(configs, USER_CONFIG),
    batchConfig: store.get(configs, BATCHES_CONFIG),
    programs: store.getAll(programs),
  }),
  null,
)(StudentList);
